import { configureStore } from '@reduxjs/toolkit'
import farmsReducer from './farms'
import oldFarmsReducer from './OldFarms'
import poolsReducer from './pools'
import pricesReducer from './prices'

export default configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: {
    farms: farmsReducer,
    oldFarms: oldFarmsReducer,
    pools: poolsReducer,
    prices: pricesReducer,
  },
})
